export default __webpack_public_path__ + "static/media/logo.fb9e70f3.png";